import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageAspectRatio',
})
export class ImageAspectRatioPipe implements PipeTransform {
  transform(imageUrl: string, aspectRatio: string): string {
    const aspectRatioRegex = /\/([0-9]+-)?[0-9]+x[0-9]+(?=\.(jpg|jpeg|png|webp|gif))/;
    if (imageUrl && aspectRatioRegex.test(imageUrl)) {
      return imageUrl.replace(aspectRatioRegex, `/$1${aspectRatio}`);
    }
    return imageUrl;
  }
}
